// export const CORE_API_ENDPOINT = 'https://www.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://www.bainisysstg.com/o365'
// export const NOTI_API_ENDPOINT = 'https://www.bainisysstg.com/notification'

// SOR
// export const CORE_API_ENDPOINT = 'http://10.0.30.10:8011/core'
// export const O365_API_ENDPOINT = 'http://10.0.30.10:8011/o365'
// export const NOTI_API_ENDPOINT = 'http://10.0.30.10:8011/notification'

export const PROFILE_CENTER_URL = 'https://backoffice.bsrsprofile.com/api'

// export const CORE_API_ENDPOINT = 'https://backend.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backend.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backend.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backbns.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backbns.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backbns.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://backgg.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://backgg.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://backgg.rmbainisys.com/notification'

// Prod
export const CORE_API_ENDPOINT = '/core'
export const O365_API_ENDPOINT = '/o365'
export const NOTI_API_ENDPOINT = '/notification'

// export const CORE_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25ex2010.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25ex2013.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'http://localhost:2800/core'
// export const O365_API_ENDPOINT = 'http://localhost:3100/o365'
// export const NOTI_API_ENDPOINT = 'http://localhost:2170/notification'

// export const CORE_API_ENDPOINT = 'https://back25o365.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25o365.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25o365.rmbainisys.com/notification'

// export const CORE_API_ENDPOINT = 'https://back25o365.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://back25o365.rmbainisys.com/o365'
// export const NOTI_API_ENDPOINT = 'https://back25o365.rmbainisys.com/notification'

// CP test
// export const CORE_API_ENDPOINT = 'https://10.0.30.10:6500/core'
// export const O365_API_ENDPOINT = 'https://10.0.30.10:6500/o365'
// export const NOTI_API_ENDPOINT = 'https://10.0.30.10:6500/notification'

// SOR
// export const CORE_API_ENDPOINT = 'https://10.0.30.10:8012/core'
// export const O365_API_ENDPOINT = 'https://10.0.30.10:8012/o365'
// export const NOTI_API_ENDPOINT = 'https://10.0.30.10:8012/notification'

// SCG
// export const CORE_API_ENDPOINT = 'https://10.0.30.11:7021/core'
// export const O365_API_ENDPOINT = 'https://10.0.30.11:7021/o365'
// export const NOTI_API_ENDPOINT = 'https://10.0.30.11:7021/notification'

export const page_footer = " © BAINISYS"

export const MIN_EXPIRE_TOKEN = 5 //min



// WEBPACK FOOTER //
// ./src/lib/api.js